export default "__VITE_ASSET__DhjXLCcW__"